<template lang="html">
  <div class="relative text-center flex flex-col justify-center items-center" v-if="type == 'stream'">
    <video
      ref="main-video"
      autoplay
      poster="offline.svg"
      @dblclick="toogleFullScreen"
      :muted="create"
    >
    </video>
    <div class="flex flex-col justify-center w-full" v-if="create" >
      <h2 class="text-4xl">Room: {{ key }}</h2>
      <div class="flex justify-center w-full mt-2">
        <input ref="url-input" class="w-96 text-center" type="text" v-model="urlRef" readonly>
        <button
          type="button"
          name="button"
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded ml-5"
          @click="copyUrl()"
        >
          Copy link
        </button>
      </div>
    </div>
  </div>
  <div class="" v-else-if="type == 'conference'">

  </div>
  <div class="" v-else>
    Type({{ type }}) not supported
  </div>
</template>

<script type="text/javascript">
  import io from 'socket.io-client'
  // import axios from 'axios'
  import { mapActions, mapMutations, mapGetters } from 'vuex'

  import modalBus from '../../bus/modal'

  const HOST = 'service.userjapa.me'

  const PeerConnection     = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection,
        SessionDescription = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitSessionDescription

  export default {
    name: 'MediaStreamRoom',
    data () {
      return {
        socket: null,
        stream: null,
        socketKeepAlive: null,
        mainConnection: null,
        members: []
      }
    },
    computed: {
      ...mapGetters({
        create: 'mediaStream/getCreate',
        type: 'mediaStream/getType',
        key: 'mediaStream/getRoomKey',
        device: 'mediaStream/getDevice',
        isMobile: 'isMobile'
      }),
      fullscreen () {
        return document.fullscreen
      },
      urlRef () {
        return document.location.href
      }
    },
    methods: {
      ...mapMutations({
        setType: 'mediaStream/setType',
        setRoomKey: 'mediaStream/setRoomKey',
      }),
      ...mapActions({
        verifyRoom: 'room/verifyRoom'
      }),
      getStream () {
        return navigator.mediaDevices.getUserMedia({
          video: !this.isMobile ? {
            deviceId: {
              exact: this.device
            }
          } : {
            facingMode: {
              exact: this.device
            }
          },
          audio: {
            mandatory: {
              googEchoCancellation: "false",
              googAutoGainControl: "false",
              googNoiseSuppression: "false",
              googHighpassFilter: "false"
            },
            optional: []
          }
        })
      },
      connect () {
        this.socket = io(`https://${HOST}`, {
          path: '/socket/media-stream'
        })

        this.connectionTimeout = setTimeout(() => {
          this.creating = false
          alert('Failed to connect to server')
          this.closeClassroom()
        }, 5000)

        this.socket.on('connect', async () => {
          if (this.connectionTimeout) {
            clearTimeout(this.connectionTimeout)
            this.connectionTimeout = null
          }

          if (this.socketKeepAlive)
            clearInterval(this.socketKeepAlive)

          this.socketKeepAlive = setInterval(() => {
            this.socket.emit('keep_alive')
          }, 5000)

          if (this.create) {
            try {
              this.stream = await this.getStream()

              this.socket.on('create_failed', () => {
                alert('Failed to connect')
              })

              if (this.type == 'stream') {
                this.$refs['main-video'].srcObject = this.stream

                this.socket.on('room_created', () => {
                  this.socket.on('joined', async socket => {
                    const connection = new PeerConnection({ iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]})

                    if ((this.stream && this.stream.active) ? true : false)
                      this.stream.getTracks().forEach(track => connection.addTrack(track, this.stream))

                    const offer = await connection.createOffer()

                    await connection.setLocalDescription(new SessionDescription(offer))

                    const member = {
                      socket,
                      connection
                    }

                    this.members.push(member)

                    this.socket.emit('make_offer', {
                      offer,
                      to: socket
                    })
                  })

                  this.socket.on('answer_made', async ({ from, answer }) => {
                    const member = this.members.find(m => m.socket == from)

                    if (member) {
                      await member.connection.setRemoteDescription(new SessionDescription(answer))
                      this.socket.emit('request_offer', from)
                    }
                  })

                  this.socket.on('offer_made', async ({ from, offer }) => {
                    const member = this.members.find(m => m.socket == from)

                    if (member) {
                      await member.connection.setRemoteDescription(new SessionDescription(offer))

                      const answer = await member.connection.createAnswer()

                      await member.connection.setLocalDescription(new SessionDescription(answer))

                      this.socket.emit('make_answer', {
                        answer,
                        to: from
                      })
                    }
                  })

                  this.socket.on('disconnected', socket => {
                    const index = this.members.findIndex(m => m.socket == socket)

                    if (index > -1) {
                      this.members[index].connection.close()
                      this.$delete(this.members, index)
                    }
                  })
                })
              }

              this.socket.emit('create', {
                type: this.type,
                room_key: this.key
              })
            } catch (error) {
              this.clearStream()
              alert('Failed to get Stream')
            }
          } else {
            this.socket.on('join_failed', () => {
              alert('Failed to join')
            })

            this.socket.on('joined', type => {
              this.setType(type)

              if (this.type == 'stream') {
                const pc = new PeerConnection({ iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]})

                pc.ontrack = async event => {
                  const video = this.$refs['main-video']

                  if (video)
                    video.srcObject = (event.streams[0])
                }

                this.mainConnection = pc

                this.socket.on('offer_made', async ({ from, offer }) => {
                  await this.mainConnection.setRemoteDescription(new SessionDescription(offer))

                  const answer = await this.mainConnection.createAnswer()

                  await this.mainConnection.setLocalDescription(new SessionDescription(answer))

                  this.socket.emit('make_answer', {
                    answer,
                    to: from
                  })

                  this.socket.on('answer_made', async ({ answer }) => {
                    await this.mainConnection.setRemoteDescription(new SessionDescription(answer))
                  })
                })

                this.socket.on('offer_requested', async from => {
                  const offer = await this.mainConnection.createOffer()

                  await this.mainConnection.setLocalDescription(new SessionDescription(offer))

                  this.socket.emit('make_offer', {
                    offer,
                    to: from
                  })
                })

                this.socket.on('disconnected', () => {
                  this.mainConnection.close()
                  this.mainConnection = null

                  this.$refs['main-video'].srcObject = null
                })
              }
            })

            this.socket.emit('join', this.key)
          }
        })
      },
      clearStream () {
        if (this.socket) {
          this.socket.disconnect(true)
          this.socket = null
        }

        if (this.stream) {
          const tracks = this.stream.getTracks()

          for (const track of tracks) {
            track.stop()
          }
        }

        if (this.socketKeepAlive) {
          clearInterval(this.socketKeepAlive)
          this.socketKeepAlive = null
        }

        if (this.mainConnection) {
          this.mainConnection.close()
          this.mainConnection = null
        }

        for (const member of this.members) {
          if (member.connection && member.connection.connectionState != 'closed')
            member.connection.close()
        }

        this.members = []
      },
      async enterRoom () {
        if (this.create)
          return this.connect()

        const data = await this.verifyRoom(this.key)

        if (data.online) {
          this.connect()
        } else {
          modalBus.$emit('SET_MESSAGE', data.message)
          modalBus.$emit('SHOW')
        }
      },
      modalClosed () {
        this.$router.replace({ name: 'MediaStream' })
      },
      toogleFullScreen () {
        if (!this.create)
          this.fullscreen ? this.exitFullScreen() : this.$refs['main-video'].requestFullscreen()
      },
      exitFullScreen () {
        if (!this.create && this.fullscreen)
          document.exitFullscreen()
      },
      copyUrl () {
        this.$refs['url-input'].select()
        this.$refs['url-input'].setSelectionRange(0, 99999)

        document.execCommand("copy")
      }
    },
    created () {
      this.setRoomKey(this.$route.params.room)
      this.enterRoom()
      modalBus.$on('CLOSED', this.modalClosed)
    },
    beforeDestroy () {
      this.clearStream()
      modalBus.$off('CLOSED', this.modalClosed)
    }
  }
</script>
